import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Switch from "@mui/material/Switch";
import lockedIcon from "images/Locked_icon.png";
import unlockedIcon from "images/Unlocked_icon.png";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import { fetchPolicyGroupSettings, updatePolicyGroupSetting, updatePolicySettingLock } from "js/Api/index";
import { Button } from '../../../Component/CommonFormEle';
import { hasValue } from "../../../helpers/common_functions";

function DisplaySettings({ user, policy, settingsFrom }) {
    const [settings, setSettings] = useState([]);
    const [sleepMode, setsleepMode] = useState(false);
    const [adaptiveBrightness, setadaptiveBrightness] = useState(false);

    const [sliderValue, setSliderValue] = useState(0); // Initial value

    const handleChange = (event) => {
        setSliderValue(event.target.value);
    };

    const updateadaptiveBrightness = (value) => {
        setadaptiveBrightness(value)
    }

    const [displaySettings, setdisplaySettings] = useState([]);
    const [selectedRecordingOption, setSelectedRecordingOption] = useState("allow");

    const isReadOnly = selectedRecordingOption !== "manage";

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await fetchPolicyGroupSettings(policy.id);

            if (response.success) {
                setSettings(response.data.polictSettings);
                setdisplaySettings(response.data.policySettingCategoryGroups);
                updatedisplaySettings(response.data.polictSettings);
                updateSelectedOption(response.data.policySettingCategoryGroups);
            } else {
                console.error("Failed to fetch settings:", response.error);
            }
        } catch (error) {
            console.error("Error fetching settings:", error);
        }
    };

    const updatedisplaySettings = (recordingSettings) => {
        recordingSettings.forEach((setting) => {
            if (setting.friendlyName === "settings.display.adaptive_brightness") {
                setadaptiveBrightness(setting.value === "true");
            }
            if (setting.friendlyName === "settings.display.sleep_mode") {
                setsleepMode(setting.value === "true");
            }

            if (setting.friendlyName === "settings.display.brightness") {
                if (hasValue(setting.value)) {
                    setSliderValue(setting.value * 100);
                }
            }
        });
    };

    const updateSelectedOption = (categoryGroups) => {
        const recordingCategory = categoryGroups.find(
            (category) => category.categoryName === "Display"
        );
        if (recordingCategory) {
            setSelectedRecordingOption(recordingCategory.locked ? "manage" : "allow");
        }
    };

    const handleSaveRecordingSettings = async () => {
        // Find the settings we need to update using friendlyName
        const settings1 = settings.find(setting =>
            setting.friendlyName === "settings.display.adaptive_brightness"
        );

        const settings2 = settings.find(setting =>
            setting.friendlyName === "settings.display.sleep_mode"
        );

        const settings3 = settings.find(setting =>
            setting.friendlyName === "settings.display.brightness"
        );

        // Prepare the settings to update
        const updatedSettings = [];

        if (settings2) {
            updatedSettings.push({
                ...settings2,
                value: sleepMode.toString()
            });
        }

        if (settings1) {
            updatedSettings.push({
                ...settings1,
                value: adaptiveBrightness.toString()
            });
        }

        if (settings3) {
            updatedSettings.push({
                ...settings3,
                value: (sliderValue / 100).toString()
            });
        }

        try {
            let hasError = false;

            for (const setting of updatedSettings) {
                const response = await updatePolicyGroupSetting(policy.id, setting.id, setting.value);

                if (!response.success) {
                    console.error(`Failed to update setting ${setting.name} (${setting.friendlyName}):`, response.error);
                    hasError = true;
                }
            }

            if (hasError) {
                toast.error("Failed to update settings");
            } else {
                toast.success("Settings updated successfully!");
                fetchSettings();
            }
        } catch (error) {
            console.error("Error updating settings:", error);
            toast.error("Failed to update settings");
        }
    };

    const handleCategoryLockChange = async (locked) => {
        const category = displaySettings.find(
            (category) => category.categoryName === "Display"
        );

        if (!category) return;

        try {
            const response = await updatePolicySettingLock(policy.id, category.id, locked);

            if (response.success) {
                // Update local state
                category.locked = locked;
                setdisplaySettings([...displaySettings]);
                setSelectedRecordingOption(locked ? "manage" : "allow");
            } else {
                console.error("Failed to update category lock:", response.error);
                toast.error("Failed to update category lock");
            }
        } catch (error) {
            console.error("Error updating category lock:", error);
            toast.error("Failed to update category lock");
        }
    };

    return (
        <div style={{ marginLeft: "40px", marginBottom: "30px" }}>
            <div style={{ display: "flex" }}>
                <h4>Display</h4>
                <div className="dropdown">
                    <button className="btn lockerBtn" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                        {selectedRecordingOption === "allow" ? (
                            <img src={unlockedIcon} style={{ height: "20px" }} />
                        ) : (
                            <img src={lockedIcon} style={{ height: "20px" }} />
                        )}
                    </button>
                    <ul className="dropdown-menu dropdown-item-ul">
                        <li onClick={() => handleCategoryLockChange(false)}>
                            <span>
                                <LockOpenRoundedIcon sx={{ width: "20px", margin: "0 5px", }} />
                            </span>
                            Allow device user and family to change these settings
                            {selectedRecordingOption === "allow" && (
                                <span style={{ float: "right", marginRight: "1em" }}>
                                    <DoneRoundedIcon />
                                </span>
                            )}
                        </li>
                        <li onClick={() => handleCategoryLockChange(true)}>
                            <span>
                                <LockRoundedIcon sx={{ width: "20px", margin: "0px 5px", }} />
                            </span>
                            Organisation manages these settings
                            {selectedRecordingOption === "manage" && (
                                <span style={{ float: "right", marginRight: "1em" }}>
                                    <DoneRoundedIcon />
                                </span>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    Adaptive Brightness
                </div>
                <div class="col">
                    <Switch checked={adaptiveBrightness} onChange={(e) => updateadaptiveBrightness(e.target.checked)} color="primary" disabled={isReadOnly} />
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    Manual Brightness
                </div>
                <div class="col mb-3">
                    {console.log(adaptiveBrightness) }
                    <input type="range" min="0" max="100" value={sliderValue} onChange={handleChange} style={{ width: '30%' }} disabled={isReadOnly || !(adaptiveBrightness === false)} />
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    Sleep Mode
                </div>
                <div class="col">
                    <Switch checked={sleepMode} onChange={(e) => setsleepMode(e.target.checked)} color="primary" disabled={isReadOnly} />
                </div>
            </div>
            <div>
                <Button onClick={handleSaveRecordingSettings} variant="black">
                    Apply
                </Button>
            </div>
        </div>
    );
}

export default DisplaySettings;